import { isMarketAllowed } from '@/hooks/use-funded-account';
import { getAllMarketStoreStates } from '@/store/use-markets-store';
import { MarketStatus } from '@/types';
import { abbrFromSym } from '@/utils/token-symbol';
import { bigIntToNum } from '@/utils/value-format';

const NEW_IPOs = [
  'SPCX',
  'BTGO',
  'EQPT',
  'MDLN',
  'FIGR',
  'GEMI',
  'STUB',
  'NTSK',
  'PTRN',
  'ALH',
  'PXED',
  'NAVN',
  'BETA',
];

const DATs = [
  'MSTR',
  'SBET',
  'BMNR',
  'NAKA',
  'UPXI',
  'DFDV',
  'ALTS',
  'STKE',
  'STSS',
  'FORD',
  'HSDT',
  'HYPD',
  'ABTC',
  'BREA',
  'AGRI',
  'BNC',
  'ASST',
  'CYPH',
];
const LAST_10: string[] = [
  'USO',
  'SNDK',
  'WDC',
  'BOX',
  'CYPH',
  'LYFT',
  'NET',
  'TGT',
];
const LAST_30D: string[] = [];

const SYMBOL_CATEGORIES = {
  TRENDING: [...LAST_10, ...LAST_30D, ...NEW_IPOs],
  Commodities: ['GC', 'SI', 'HG', 'PL', 'CL', 'BZ', 'NG'],
  DATs,
  // 'S&P500': [
  //   'NVDA',
  //   'MSFT',
  //   'AAPL',
  //   'AMZN',
  //   'GOOG',
  //   'GOOGL',
  //   'META',
  //   'AVGO',
  //   'TSLA',
  //   'BRK.B',
  //   'JPM',
  //   'WMT',
  //   'LLY',
  //   'ORCL',
  //   'V',
  //   'NFLX',
  //   'MA',
  //   'XOM',
  //   'COST',
  //   'JNJ',
  //   'PG',
  //   'PLTR',
  //   'HD',
  //   'BAC',
  //   'ABBV',
  //   'KO',
  //   'PM',
  //   'GE',
  //   'CSCO',
  //   'UNH',
  //   'IBM',
  //   'CVX',
  //   'TMUS',
  //   'AMD',
  //   'WFC',
  //   'CRM',
  //   'ABT',
  //   'MS',
  //   'AXP',
  //   'LIN',
  //   'DIS',
  //   'MCD',
  //   'INTU',
  //   'GS',
  //   'MRK',
  //   'BX',
  //   'RTX',
  //   'NOW',
  //   'TXN',
  //   'CAT',
  //   'T',
  //   'UBER',
  //   'PEP',
  //   'BKNG',
  //   'ISRG',
  //   'ACN',
  //   'VZ',
  //   'BA',
  //   'BLK',
  //   'QCOM',
  //   'SCHW',
  //   'C',
  //   'SPGI',
  //   'AMGN',
  //   'TMO',
  //   'AMAT',
  //   'NEE',
  //   'ADBE',
  //   'GEV',
  //   'BSX',
  //   'HON',
  //   'SYK',
  //   'PGR',
  //   'ETN',
  //   'PFE',
  //   'DHR',
  //   'UNP',
  //   'DE',
  //   'GILD',
  //   'ANET',
  //   'TJX',
  //   'MU',
  //   'CMCSA',
  //   'PANW',
  //   'LRCX',
  //   'KKR',
  //   'KLAC',
  //   'ADP',
  //   'APH',
  //   'LOW',
  //   'VRTX',
  //   'ADI',
  //   'CRWD',
  //   'COP',
  //   'MDT',
  //   'CB',
  //   'LMT',
  //   'NKE',
  //   'SBUX',
  //   'AMT',
  //   'MMC',
  //   'PLD',
  //   'ICE',
  //   'WELL',
  //   'SO',
  //   'COIN',
  //   'CME',
  //   'DASH',
  //   'MO',
  //   'INTC',
  //   'TT',
  //   'CEG',
  //   'BMY',
  //   'RCL',
  //   'FI',
  //   'DUK',
  //   'WM',
  //   'PH',
  //   'MCO',
  //   'MCK',
  //   'SNPS',
  //   'TDG',
  //   'MDLZ',
  //   'APO',
  //   'HCA',
  //   'CTAS',
  //   'CDNS',
  //   'SHW',
  //   'MMM',
  //   'ABNB',
  //   'UPS',
  //   'DELL',
  //   'COF',
  //   'CI',
  //   'CVS',
  //   'GD',
  //   'AJG',
  //   'FTNT',
  //   'EMR',
  //   'ORLY',
  //   'ELV',
  //   'PNC',
  //   'AON',
  //   'ECL',
  //   'RSG',
  //   'ITW',
  //   'MAR',
  //   'EQIX',
  //   'NOC',
  //   'HWM',
  //   'CMG',
  //   'PCAR',
  //   'AMP',
  //   'GWW',
  //   'OKE',
  //   'CTVA',
  //   'LHX',
  //   'SRE',
  //   'D',
  //   'DDOG',
  //   'CMI',
  //   'KR',
  //   'SLB',
  //   'AIG',
  //   'TGT',
  //   'HES',
  //   'GLW',
  //   'CCI',
  //   'KDP',
  //   'VLO',
  //   'F',
  //   'EW',
  //   'CPRT',
  //   'MSCI',
  //   'TTWO',
  //   'EXC',
  //   'GRMN',
  //   'KMB',
  //   'ROST',
  //   'VRSK',
  //   'OXY',
  //   'KVUE',
  //   'IDXX',
  //   'FIS',
  //   'PEG',
  //   'AME',
  //   'CBRE',
  //   'YUM',
  //   'DHI',
  //   'MCHP',
  //   'XEL',
  //   'FANG',
  //   'ROK',
  //   'OTIS',
  //   'CAH',
  //   'BKR',
  //   'CCL',
  //   'EA',
  //   'SYY',
  //   'FICO',
  //   'RMD',
  //   'EQT',
  //   'CTSH',
  //   'WAB',
  //   'ED',
  //   'PRU',
  //   'DAL',
  //   'TRGP',
  //   'ETR',
  //   'CSGP',
  //   'EBAY',
  //   'VICI',
  //   'IR',
  //   'LVS',
  //   'GEHC',
  //   'LYV',
  //   'VMC',
  //   'HIG',
  //   'BRO',
  //   'MPWR',
  //   'ODFL',
  //   'WEC',
  //   'TKO',
  //   'HSY',
  //   'ACGL',
  //   'EXR',
  //   'DXCM',
  //   'MLM',
  //   'ANSS',
  //   'KHC',
  //   'A',
  //   'EFX',
  //   'NUE',
  //   'SMCI',
  //   'XYL',
  //   'RJF',
  //   'STX',
  //   'WBD',
  //   'EL',
  //   'DD',
  //   'MTB',
  //   'WTW',
  //   'STT',
  //   'VTR',
  //   'TSCO',
  //   'STZ',
  //   'IRM',
  //   'PCG',
  //   'UAL',
  //   'FITB',
  //   'AVB',
  //   'LEN',
  //   'NRG',
  //   'IT',
  //   'DTE',
  //   'K',
  //   'AWK',
  //   'BR',
  //   'KEYS',
  //   'IQV',
  //   'HUM',
  //   'GIS',
  //   'IP',
  //   'LULU',
  //   'ROL',
  //   'HPE',
  //   'VRSN',
  //   'SYF',
  //   'PPG',
  //   'EQR',
  //   'AEE',
  //   'PPL',
  //   'ADM',
  //   'WRB',
  //   'EXE',
  //   'DOV',
  //   'TDY',
  //   'SBAC',
  //   'FOXA',
  //   'VLTO',
  //   'ON',
  //   'CBOE',
  //   'DG',
  //   'MTD',
  //   'ATO',
  //   'DRI',
  //   'NTRS',
  //   'HBAN',
  //   'TYL',
  //   'GDDY',
  //   'FOX',
  //   'SW',
  //   'ES',
  //   'CHD',
  //   'CNP',
  //   'JBL',
  //   'PTC',
  //   'FE',
  //   'WDC',
  //   'CDW',
  //   'CINF',
  // ],
  // NASDAQ100: [
  //   'NVDA',
  //   'MSFT',
  //   'AAPL',
  //   'AMZN',
  //   'META',
  //   'AVGO',
  //   'GOOGL',
  //   'GOOG',
  //   'TSLA',
  //   'NFLX',
  //   'COST',
  //   'PLTR',
  //   'ASML',
  //   'CSCO',
  //   'AMD',
  //   'TMUS',
  //   'AZN',
  //   'LIN',
  //   'INTU',
  //   'TXN',
  //   'PEP',
  //   'ISRG',
  //   'BKNG',
  //   'QCOM',
  //   'ARM',
  //   'AMGN',
  //   'SHOP',
  //   'AMAT',
  //   'ADBE',
  //   'HON',
  //   'PDD',
  //   'GILD',
  //   'PANW',
  //   'CMCSA',
  //   'MSTR',
  //   'LRCX',
  //   'MU',
  //   'KLAC',
  //   'ADP',
  //   'MELI',
  //   'APP',
  //   'VRTX',
  //   'ADI',
  //   'CRWD',
  //   'SBUX',
  //   'DASH',
  //   'INTC',
  //   'CEG',
  //   'MDLZ',
  //   'SNPS',
  //   'CDNS',
  //   'CTAS',
  //   'ABNB',
  //   'FTNT',
  //   'ORLY',
  //   'MAR',
  //   'PYPL',
  //   'CSX',
  //   'ADSK',
  //   'MRVL',
  //   'WDAY',
  //   'REGN',
  //   'ROP',
  //   'MNST',
  //   'AXON',
  //   'AEP',
  //   'NXPI',
  //   'FAST',
  //   'CHTR',
  //   'PAYX',
  //   'PCAR',
  //   'TEAM',
  //   'DDOG',
  //   'KDP',
  //   'ZS',
  //   'CPRT',
  //   'TTWO',
  //   'CCEP',
  //   'EXC',
  //   'VRSK',
  //   'ROST',
  //   'IDXX',
  //   'TTD',
  //   'FANG',
  //   'MCHP',
  //   'XEL',
  //   'BKR',
  //   'EA',
  //   'CTSH',
  //   'CSGP',
  //   'GEHC',
  //   'ODFL',
  //   'DXCM',
  //   'ANSS',
  //   'KHC',
  //   'WBD',
  //   'LULU',
  //   'ON',
  //   'CDW',
  //   'GFS',
  //   'BIIB',
  // ],
  ETFs: [
    'SPY',
    'QQQ',
    'GLD',
    'GDX',
    'SIL',
    'SLV',
    'URA',
    'REMX',
    'LIT',
    'IWM',
    'EWY',
  ],
  INDICES: ['SPX', 'NDX', 'RTY'],
};

export type SymbolCategory = keyof typeof SYMBOL_CATEGORIES;

// const isRestrictedForCapital = (symbol: string): boolean => {
//   const { activeWalletType } = useAccountStore.getState();

//     if (activeWalletType !== WalletType.FUNDED) return false;
//     const { marketSpec } = useMarketStore(symbol).getState();
//     if (marketSpec.asset !== AssetType.CRYPTO) return false;
//     const allowed = new Set(['BTC-PERP', 'ETH-PERP', 'SOL-PERP']);
//     return !allowed.has(symbol);
//   };

// TODO: better way for restricted e.g. only display allowed

export function getTrendingSymbols(options?: { restricted?: boolean }) {
  const trending = new Set() as Set<string>;
  const markets = getAllMarketStoreStates();

  // const hasNonZeroPriceChange = (symbol: string): boolean => {
  //   const { marketData } = useMarketStore(symbol).getState();
  //   return marketData.priceChangePct !== 0n;
  // };

  // const filteredSymbols = symbols.filter(
  //   (symbol) => !isRestrictedForCapital(symbol),
  // );

  Object.keys(markets)
    .filter((symbol) => {
      if (markets[symbol].marketSpec.status !== MarketStatus.TRADING)
        return false;
      if (!SYMBOL_CATEGORIES.TRENDING.includes(abbrFromSym(symbol)))
        return false;
      return !options?.restricted || isMarketAllowed(symbol);
    })
    .sort(
      (a, b) =>
        SYMBOL_CATEGORIES.TRENDING.indexOf(abbrFromSym(a)) -
        SYMBOL_CATEGORIES.TRENDING.indexOf(abbrFromSym(b)),
    )
    .forEach((symbol) => trending.add(symbol));

  Object.keys(markets)
    .filter((symbol) => {
      if (markets[symbol].marketSpec.status !== MarketStatus.TRADING)
        return false;
      return !options?.restricted || isMarketAllowed(symbol);
    })
    .sort((a, b) => {
      const { marketData: aMarketData, marketSpec: aMarketSpec } = markets[a];
      const { marketData: bMarketData, marketSpec: bMarketSpec } = markets[b];
      const aQuoteVolume = bigIntToNum(
        aMarketData.quoteVolume ?? 0n,
        aMarketSpec.priceDecimals + aMarketSpec.sizeDecimals,
      );
      const bQuoteVolume = bigIntToNum(
        bMarketData.quoteVolume ?? 0n,
        bMarketSpec.priceDecimals + bMarketSpec.sizeDecimals,
      );
      return bQuoteVolume - aQuoteVolume;
    })
    .slice(0, 5)
    .forEach((symbol) => trending.add(symbol));

  return trending;
}

export const SYMBOLS_BY_MARKET_CAP = [
  'NVDA',
  'MSFT',
  'AAPL',
  'AMZN',
  'GOOGL',
  'META',
  'AVGO',
  'TSLA',
  'JPM',
  'WMT',
  'LLY',
  'V',
  'ORCL',
  'MA',
  'NFLX',
  'XOM',
  'COST',
  'JNJ',
  'PLTR',
  'HD',
  'PG',
  'BAC',
  'ABBV',
  'CVX',
  'KO',
  'GE',
  'AMD',
  'WFC',
  'TMUS',
  'CSCO',
  'UNH',
  'CRM',
  'PM',
  'IBM',
  'MS',
  'GS',
  'INTU',
  'LIN',
  'ABT',
  'AXP',
  'BX',
  'DIS',
  'MRK',
  'MCD',
  'RTX',
  'NOW',
  'CAT',
  'T',
  'PEP',
  'UBER',
  'BKNG',
  'TMO',
  'ISRG',
  'VZ',
  'C',
  'SCHW',
  'QCOM',
  'BA',
  'GEV',
  'ACN',
  'BLK',
  'TXN',
  'SHOP',
  'SPGI',
  'AMGN',
  'BSX',
  'ADBE',
  'ETN',
  'SYK',
  'AMAT',
  'NEE',
];

export default SYMBOL_CATEGORIES;
